export default __webpack_public_path__ + "static/media/instagram_logo_white.726c56f7.svg";